export default __webpack_public_path__ + "static/media/result1.431bd92b.png";